import { defineRecipe } from "@chakra-ui/react";

const textareaRecipe = defineRecipe({
  className: "chakra-textarea",
  base: {
    borderRadius: "6px",
    padding: "12px",
    width: "100%",
    height: "auto",
    border: "2px solid",
    borderColor: "lines",
    display: "flex",
    flexDirection: "row",
    textAlign: "start",
  },
  variants: {
    variant: {
      outline: {
        bgColor: "input",
        borderColor: "lines",
        color: "base.700",
        _invalid: {
          borderColor: "error.element",
          focusRingColor: "error.element",
        },
        _focusVisible: {
          outline: "none",
        },
        _focus: {
          borderColor: "input.focus",
          focusRingColor: "input.focus",
        },
        _disabled: {
          layerStyle: "disabled",
          backgroundColor: "base.400",
          borderColor: "lines",
          cursor: "not-allowed",
          color: "text.soft",
        },
        _placeholder: {
          color: "base.600",
        },
      },
      legacy: {
        fontSize: { base: "12px", md: "14px" },
        lineHeight: "23px",
        borderColor: "gray.300",
        borderRadius: "8px",
        borderWidth: "1px",
        padding: { base: "10px 12px", md: "14px 16px" },
        color: "gray.900",
        _focus: {
          outline: "none",
          boxShadow: "none",
        },
        _placeholder: {
          color: "text.soft",
        },
      },
    },
    size: {
      xs: {},
      sm: {},
      md: {},
      lg: {},
    },
  },
  defaultVariants: {
    variant: "legacy",
    size: "md",
  },
});

export default textareaRecipe;
